import { CircularProgress, Stack } from '@mui/material'
import { useOutletContext } from 'react-router-dom'
import type { IProjectResponse } from '../../../../../api/types'
import { ProjectUserMatchesBlock } from '../../Needs/ProjectUserMatchesBlock'

/** Рекомендации по ресурсам (что нужно) для текущего проекта. */
export const ProjectRecommendationsWhatNeeded = () => {
  const project = useOutletContext<IProjectResponse>()
  const projectId = project?.id

  if (!projectId) {
    return (
      <Stack alignItems="center" justifyContent="center" py={4}>
        <CircularProgress />
      </Stack>
    )
  }

  return <ProjectUserMatchesBlock projectId={projectId} kind="resource" />
}
